import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'bra-number',
  templateUrl: './bra-number.component.html',
  styleUrls: ['./bra-number.component.css']
})
export class BraNumberComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  change(newValue) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  @Input()
  max: number;
  
  constructor() { }

  ngOnInit() {
    if(this.max == null){
      this.max = 99999;
    }

  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-number/bra-number.component.ts